import React from 'react';
import { type Theme, useStyletron } from 'baseui';
import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import type { StyleObject } from 'styletron-react';
import type { SpanPositionT } from '../../../types/frame-timeline-v4';
import { hasEndEdge } from '../../../utils/frame-timeline-v4';
const getLabelSliceStyle = (theme: Theme, offsetPx: number, clipEnd: boolean): StyleObject => ({
  position: 'absolute',
  top: '0px',
  bottom: '0px',
  left: `${-offsetPx}px`,
  // Reserve room for the end resize handle on the trailing-edge cell and clip the text before it.
  ...(clipEnd ? {
    right: theme.sizing.scale550,
    overflow: 'hidden'
  } : {}),
  display: 'flex',
  alignItems: 'center',
  paddingLeft: theme.sizing.scale100,
  whiteSpace: 'nowrap',
  color: theme.colors.contentSecondary,
  ...theme.typography.LabelXSmall
});
type SpanValueLabelPropsT = {
  framesIntoSpan: number;
  position: SpanPositionT;
  cellWidth: number;
  value?: string;
};

/* A clipped text slice drawn per cell, offset left so a span's cells read as one continuous
 string; the tooltip surfaces the full value on hover. */
export const SpanValueLabel = ({
  framesIntoSpan,
  position,
  cellWidth,
  value
}: SpanValueLabelPropsT) => {
  const [css, theme] = useStyletron();
  if (!value || framesIntoSpan < 1) {
    return null;
  }
  const offsetPx = (framesIntoSpan - 1) * cellWidth;
  return <StatefulTooltip content={value} placement={PLACEMENT.top}>
      <div data-testid="span-value-label" className={css(getLabelSliceStyle(theme, offsetPx, hasEndEdge(position)))}>
        {value}
      </div>
    </StatefulTooltip>;
};